import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

export async function addContractAddendum(
  planId: string,
  text: string,
  lines: Array<string>,
) {
  return fetchWrapper(endpoint + `/v1/contract-addendum`, {
    method: 'post',
    body: JSON.stringify({
      planId,
      text: text,
      lines: JSON.stringify(lines),
    }),
  });
}
